import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScopusComponent } from './simple-icons-scopus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScopusComponent ],
    exports:      [ SimpleIconsScopusComponent ],
    bootstrap:    []
})
export class SimpleIconsScopusModule {}
